const colors = ["#3dc83d", "#7676f4", "#e88787", "#fca92e"];

const groups_fi = ["Kuuloaisti", "Näköaisti", "Tuntoaisti", "Hajuaisti"];
const groups_en = ["Sense of hearing", "Sense of sight", "Sense of touch", "Sense of smell"];
const groupIcons = ["hearing", "visibility", "pan_tool", "spa"];

const tresh1 = 0.25, tresh2 = 0.6, tresh3 = 0.85;

const pageTitles_fi = [
    "Arvioi tilan akustisia ominaisuuksia",
    "Tilassa kuuluu häiritsevää ääntä...",
    "Tilassa kuuluu häiritsevää ääntä...",
    "Tilassa kuuluu häiritsevää ääntä...",
    "Tilassa kuuluu häiritsevää ääntä...",
    "Tilassa syntyy häiritsevää näköaistimusta...",
    "Tilassa syntyy häiritsevää näköaistimusta...",
    "Tilassa syntyy häiritsevää näköaistimusta...",
    "Arvioi tilan visuaalisia ominaisuuksia",
    "Tilassa syntyy häiritsevää tuntoaistimusta...",
    "Tilassa syntyy häiritsevää tuntoaistimusta...",
    "Tilassa syntyy häiritsevää tuntoaistimusta...",
    "Tilassa on tuntoaistin kannalta hankala",
    "Tilassa on häiritsevä haju, joka johtuu...",
    "Tilassa on häiritsevä haju, joka johtuu...",
    "Tilassa on häiritsevä haju, joka johtuu..."
];

const pageTitles_en = [
    "Assess the acoustic properties of the space",
    "There is disturbing noise in the space",
    "There is disturbing noise in the space",
    "There is disturbing noise in the space",
    "There is disturbing noise in the space",
    "There are disturbing visual sensations",
    "There are disturbing visual sensations",
    "There are disturbing visual sensations",
    "Assess the visual properties of the space",
    "There are disturbing touch sensations",
    "There are disturbing touch sensations",
    "There are disturbing touch sensations",
    "The space has something difficult from the viewpoint of the sense of touch",
    "There is a disturbing smell in the space",
    "There is a disturbing smell in the space",
    "There is a disturbing smell in the space"
]

const emptyQuestions = [
    {
        id: "q1-1",
        value: 0,
        group: 1,
        page: 1,
        type: 0,
        title: "Tilan yleinen akustiikka on heikko",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-2",
        value: 0,
        group: 1,
        page: 1,
        type: 0,
        title: "Tilassa kuuluu häiritsevää taustaääntä",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-3",
        value: 0,
        group: 1,
        page: 2,
        type: 0,
        title: "Pattereista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-4",
        value: 0,
        group: 1,
        page: 2,
        type: 0,
        title: "Ilmastoinnista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-5",
        value: 0,
        group: 1,
        page: 2,
        type: 0,
        title: "Valaistuksesta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-6",
        value: 0,
        group: 1,
        page: 2,
        type: 0,
        title: "It-laitteista tai muista sähkölaitteista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },

    {
        id: "q1-2b",
        value: 0,
        group: 1,
        page: 3,
        type: 0,
        title: "Taustaäänet kumuloituvat",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-4b",
        value: 0,
        group: 1,
        page: 3,
        type: 0,
        title: "Huonekalujen käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-5b",
        value: 0,
        group: 1,
        page: 3,
        type: 0,
        title: "Ovien käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-2c",
        value: 0,
        group: 1,
        page: 4,
        type: 0,
        title: "Lattialla käveltäessä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-4c",
        value: 0,
        group: 1,
        page: 4,
        type: 0,
        title: "Mikrofonin käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-5c",
        value: 0,
        group: 1,
        page: 4,
        type: 0,
        title: "Ihmisten puheensorinasta tai muusta hälystä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-1d",
        value: 0,
        group: 1,
        page: 5,
        type: 0,
        title: "Ihmisten arkiaskareista/-tekemisistä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-2d",
        value: 0,
        group: 1,
        page: 5,
        type: 0,
        title: "Taustamusiikista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-3d",
        value: 0,
        group: 1,
        page: 5,
        type: 0,
        title: "Rakennuksen info- ja/tai hälytysäänistä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-4d",
        value: 0,
        group: 1,
        page: 5,
        type: 0,
        title: "Rakennuksen ulkopuolelta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q1-5d",
        value: 0,
        group: 1,
        page: 5,
        type: 1,
        title: "Tila on erittäin hiljainen",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-1",
        value: 0,
        group: 2,
        page: 6,
        type: 0,
        title: "Yleisestä valaistuksesta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-2",
        value: 0,
        group: 2,
        page: 6,
        type: 0,
        title: "Yksittäisistä häiritsevistä valoista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-3",
        value: 0,
        group: 2,
        page: 6,
        type: 0,
        title: "Heijastumista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-1a",
        value: 0,
        group: 2,
        page: 7,
        type: 0,
        title: "Valojen ja varjojen vaihteluista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-2a",
        value: 0,
        group: 2,
        page: 7,
        type: 0,
        title: "Isoista peileistä tai lasipinnoista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-3a",
        value: 0,
        group: 2,
        page: 7,
        type: 0,
        title: "Voimakkaiden värien ja/tai kontrastien käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-4a",
        value: 0,
        group: 2,
        page: 7,
        type: 0,
        title: "Hyvin yksipuolisten värien käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-5a",
        value: 0,
        group: 2,
        page: 7,
        type: 0,
        title: "Graafisten kuvioiden käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-1b",
        value: 0,
        group: 2,
        page: 8,
        type: 0,
        title: "Sekavien pintamateriaalien käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-3b",
        value: 0,
        group: 2,
        page: 8,
        type: 0,
        title: "Liikkuvasta kuvasta/näkymästä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-4b",
        value: 0,
        group: 2,
        page: 8,
        type: 0,
        title: "Rakennuksen sekavasta yleisilmeestä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-5b",
        value: 0,
        group: 2,
        page: 9,
        type: 0,
        title: "Tilassa on hankalia syvyyden hahmottamista vaativia paikkoja",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-1c",
        value: 0,
        group: 2,
        page: 9,
        type: 1,
        title: "Tilassa on käytetty selkiyttäviä opasteita/karttoja/ohjaavia viivoja.",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q2-3c",
        value: 0,
        group: 2,
        page: 9,
        type: 1,
        title: "Tila on kooltaan sopiva käyttötarkoitukseensa",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-2",
        value: 0,
        group: 3,
        page: 10,
        type: 0,
        title: "Tilan vetoisuudesta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-3",
        value: 0,
        group: 3,
        page: 10,
        type: 0,
        title: "Käytetyistä pintamateriaaleista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-1a",
        value: 0,
        group: 3,
        page: 11,
        type: 0,
        title: "Kalusteiden tuntumasta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-2a",
        value: 0,
        group: 3,
        page: 11,
        type: 0,
        title: "Kalusteiden mittasuhteista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-3a",
        value: 0,
        group: 3,
        page: 11,
        type: 0,
        title: "Lattiatuntumasta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-4a",
        value: 0,
        group: 3,
        page: 11,
        type: 0,
        title: "Lattialämmityksestä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-5a",
        value: 0,
        group: 3,
        page: 12,
        type: 0,
        title: "Tilan ahtaudesta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-1b",
        value: 0,
        group: 3,
        page: 12,
        type: 0,
        title: "Ulko-oven yhteydessä voimakkaasti puhaltavista ilmastointilaitteista/lämpöverhosta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-2b",
        value: 0,
        group: 3,
        page: 12,
        type: 0,
        title: "Kuivasta huoneilmasta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-3b",
        value: 0,
        group: 3,
        page: 13,
        type: 0,
        title: "Suihku",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-4b",
        value: 0,
        group: 3,
        page: 13,
        type: 0,
        title: "Wc-istuimen huuhtelumekanismi",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q3-5b",
        value: 0,
        group: 3,
        page: 13,
        type: 0,
        title: "Ovenkahva/-vedin",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-1",
        value: 0,
        group: 4,
        page: 14,
        type: 0,
        title: "Jostakin yleistuoksusta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-2",
        value: 0,
        group: 4,
        page: 14,
        type: 0,
        title: "Käytetyistä materiaaleista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-3",
        value: 0,
        group: 4,
        page: 14,
        type: 0,
        title: "Tuoksuvista kasveista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-4",
        value: 0,
        group: 4,
        page: 14,
        type: 0,
        title: "Raikastimien käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-1a",
        value: 0,
        group: 4,
        page: 15,
        type: 0,
        title: "Kynttilöiden polttamisesta",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-2a",
        value: 0,
        group: 4,
        page: 15,
        type: 0,
        title: "Hajustettujen pesuaineiden käytöstä",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-3a",
        value: 0,
        group: 4,
        page: 15,
        type: 0,
        title: "Ihmisistä tilassa",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-4a",
        value: 0,
        group: 4,
        page: 15,
        type: 0,
        title: "Ilmastoinnin kautta tulevista hajuista",
        isFull: false,
        canSkip: true,
        skip: false,
        details: ""
    },
    {
        id: "q4-5a",
        value: 0,
        group: 4,
        page: 15,
        type: 0,
        title: "Tilassa on muu tunnistamaton tuoksun lähde",
        isFull: true,
        canSkip: true,
        skip: false,
        details: ""
    }
]

const questionTexts_fi = ["Tilan yleinen akustiikka on heikko","Tilassa kuuluu häiritsevää taustaääntä","Pattereista","Ilmastoinnista","Valaistuksesta","It-laitteista tai muista sähkölaitteista","Taustaäänet kumuloituvat","Huonekalujen käytöstä","Ovien käytöstä","Lattialla käveltäessä","Mikrofonin käytöstä","Ihmisten puheensorinasta tai muusta hälystä","Ihmisten arkiaskareista/-tekemisistä","Taustamusiikista","Rakennuksen info- ja/tai hälytysäänistä","Rakennuksen ulkopuolelta","Tila on erittäin hiljainen","Yleisestä valaistuksesta","Yksittäisistä häiritsevistä valoista","Heijastumista","Valojen ja varjojen vaihteluista","Isoista peileistä tai lasipinnoista","Voimakkaiden värien ja/tai kontrastien käytöstä","Hyvin yksipuolisten värien käytöstä","Graafisten kuvioiden käytöstä","Sekavien pintamateriaalien käytöstä","Liikkuvasta kuvasta/näkymästä","Rakennuksen sekavasta yleisilmeestä","Tilassa on hankalia syvyyden hahmottamista vaativia paikkoja","Tilassa on käytetty selkiyttäviä opasteita/karttoja/ohjaavia viivoja.","Tila on kooltaan sopiva käyttötarkoitukseensa","Tilan vetoisuudesta","Käytetyistä pintamateriaaleista","Kalusteiden tuntumasta","Kalusteiden mittasuhteista","Lattiatuntumasta","Lattialämmityksestä","Tilan ahtaudesta","Ulko-oven yhteydessä voimakkaasti puhaltavista ilmastointilaitteista/lämpöverhosta","Kuivasta huoneilmasta","Suihku","Wc-istuimen huuhtelumekanismi","Ovenkahva/-vedin","Jostakin yleistuoksusta","Käytetyistä materiaaleista","Tuoksuvista kasveista","Raikastimien käytöstä","Kynttilöiden polttamisesta","Hajustettujen pesuaineiden käytöstä","Ihmisistä tilassa","Ilmastoinnin kautta tulevista hajuista","Tilassa on muu tunnistamaton tuoksun lähde"]
const questionTexts_en = ["The overall acoustics of the space are poor", "There is disturbing background noise in the space", "from radiators", "from air conditioning", "from lighting", "from IT equipment or other electrical devices", "Background noises are cumulative", "from the use of furniture", "from the use of doors", "from people walking on the floor", "from the use of microphones", "from people talking or other noise", "from people’s daily chores or activities", "from background music", "from the information and/or alarm sounds of the building", "from outside the building", "The space is very quiet", "from general lighting", "from individual disturbing lights", "from reflections", "from the variations in light and shade", "from large mirrors or glass surfaces", "from the use of strong colours and/or contrasts", "from the use of a very limited range of colours", "from the use of graphic patterns", "from the use of confusing surface materials", "from a moving image/view", "from the unclear overall look of the building", "There are difficult places in the space that require depth perception", "The space is equipped with clarifying signs/maps/guiding lines", "The space is of an appropriate size for its intended use", "from the draughtiness of the space", "from the surface materials used", "from the feel of the furniture", "from the dimensions of the furniture", "from the feel of the floor", "from underfloor heating", "from lack of space", "from air conditioners/heat curtain at the external door with strong winds", "from dry indoor air", "Shower", "Toilet seat flushing mechanism", "Door handle/pull", "from some general smell", "from materials used", "from scented plants", "from the use of fresheners", "from burning candles", "from the use of perfumed detergents", "from the people in the space", "from smells coming through air conditioning", "from some other unidentified source of smell in the space"];

// function getQuestionsFile() {

//     const q = emptyQuestions.map(quest => {
//         return `"${quest.title}",`;
//     });

//     const data = new Blob(q, {type: 'text/plain'});

//     // if (textFile !== null) {
//     //     window.URL.revokeObjectURL(textFile);
//     // }

//     const textFile = window.URL.createObjectURL(data);

//     // returns a URL you can use as a href
//     return textFile;
// }

function initQuestionsValues() {
    for(let i = 0; i < questions.length; i++) {
        questions[i].value = 0;
    }
}

const info = [
    { isShowed: false, group: 1 },
    { isShowed: false, group: 2 },
    { isShowed: false, group: 3 },
    { isShowed: false, group: 4 }
];

const infoContent_fi = [
    `Ensimmäiseksi kartoitetaan tilojen akustisia ominaisuuksia. Tilan äänimaailma ja akustiikka on tärkeä osa aistiesteetöntä
    suunnittelua. Koska erilaiset ääniherkkyydet ovat aistiherkkyyksistä yleisimpiä, on asiaan tärkeää kiinnittää huomiota.
    Aistiesteettömässä tilassa tavoitellaan miellyttävää äänimaisemaa, jossa ei ole liikaa taustamelua tai häiritsevää
    kaikumista. Monelle aistiherkälle kuuloaistin kannalta kuormittavia ärsykkeitä ovat yllättävät, kovat tai tiettyä taajuutta
    olevat äänet sekä yleinen hälinä. Ääni kulkee tilassa pääsääntöisesti heijastuen erilaisista pinnoista. Kovat materiaalit ja
    pinnat heijastavatkin ääntä tehokkaammin kuin pehmeät`,

    `Seuraavaksi kartoitetaan tilojen visuaalista ilmettä. Aistiesteettömässä tilassa
    tavoitellaan harmonista ja selkeää kokonaisuutta. Yleensä suositaan
    maanläheisiä ja murrettuja sävyjä sekä ylöspäin vaalenevaa värimaailmaa.
    Epäsuora, tilan hahmottamista tukeva ja säädettävissä oleva valaistus tukee
    aistiesteettömyyttä. Samoin pyöreät ja ovaalit muodot istuvat hyvin
    aistiesteettömyyteen. Aistiherkälle näköaistin kannalta kuormittavia ovat
    monesti hyvin voimakkaat värit, voimakkaat/sekavat pintamateriaalit ja
    kuvioinnit. Samoin häikäisevät valot ja pinnat tai ihmisvilinä voi tuottaa ei-toivottua
    näköärsytystä.`,

    `Kartoituksen kolmannessa osa-alueessa kartoitetaan tiloja
    tuntoaistin näkökulmasta. Kalusteiden ja materiaalien valinnassa
    tuntoaistilla on keskeinen rooli. Tuntoaistin kohdalla pohditaan,
    miten miellyttävinä ja monipuolisina tilassa olevat materiaalit
    koetaan. Aistiherkälle tuntoaistin kannalta kuormittavia
    elementtejä voivat olla kalusteiden vääränlainen mitoitus,
    ikäväntuntuiset materiaalit (kuten kovin karheat, sähköiset tai
    kylmäntuntuiset) tai liian lämpimäksi tai kylmäksi koettu
    sisälämpötila.`,

    `Lopuksi kartoitetaan tiloja hajuaistin näkökulmasta. Rakennus- ja sisustusmateriaalit sekä huonekalut ovat yleisimpiä
    hajujen lähteitä. Muita sisäilmaan vaikuttavia tekijöitä ovat muun muassa ilmanvaihto, rakennustapa, rakennuksen
    sijainti, tilankäyttäjät sekä sääolot. Hyvä sisäilma vaikuttaa positiivisesti tilankäyttävien viihtyvyyteen, terveyteen sekä
    vireystilaan.
    Sisäilmassa olevia hajuja ja tuoksuja on lähes mahdoton välttää kokonaan, mutta jo usein tyydyttävään lopputulokseen
    päästään pitämällä huolta tilojen siisteydestä ja hygieniasta. Tärkeintä on siis lähtökohtaisesti selvittää hajunlähde ja
    toimia sen poistamiseksi. Tuoksu- ja hajutekijöissä tulee myös huomioida, etteivät kaikki yksilöt eivät koe niitä
    kuormittaviksi eivätkä kaikki hajut eivät ole suinkaan vain negatiivisia. Keskimäärin miellyttävimmiksi on koettu etenkin
    erilaiset luonnosta lähtöisin ovat tuoksut.`
]

const infoContent_en = [
    "The first step is to survey the acoustic properties of the space. The sound environment and acoustics of a space are an important part of the sensory-accessible design. As different sound sensitivities are the most common sensory sensitivities, it is very important to pay attention to this issue. The goal for a sensory-accessible space is a pleasant sound soundscape where there isn’t too much background noise or disturbing echoing. Unexpected, loud sounds or sounds of a certain frequency, as well as general noise, can put a strain on the sense of hearing of many sensory-sensitive people. Sound travels in a space generally by reflecting from different surfaces. Hard materials and surfaces reflect sound more intensively than soft ones.",
    "The next step is to survey the visual appearance of the space. The goal for a sensory-accessible space is to create a harmonius and clear overall impression. In general, earthy and broken colours are preferred as well as an upward fading colour scheme.  Indirect lighting that helps the perception of the space and is adjustable supports sensory accessibility. Similarly, round and oval shapes are well suited for sensory accessibility. Strong colours, strong/unclear surface materials and textures often put a strain on the sense of sight of sensory-sensitive people. In the same way, glaring lights and surfaces or a throng of people can cause unwanted visual simulation.",
    "In the third part of the survey, the spaces are surveyed from the viewpoint of the sense of touch. The sense of touch plays a key role in the selection of furniture and materials. When thinking about the sense of touch, one must consider how pleasant and versatile the materials in the space are felt to be. Elements that can put a strain on the sense of touch of sensory-sensitive people may include incorrectly sized furniture, unpleasant materials (such as those that are too rough, electric or cold to touch) or indoor temperature that is felt as too warm or too cold. ",
    "Lastly, we survey spaces from the viewpoint of the sense of smell. Construction and interior materials as well as furniture are the most common sources of smells. Other factors influencing indoor air are, for example, ventilation, building design, the location of the building, its users and weather conditions. Good indoor air has a positive effect on the comfort, health and energy of the people using the space. It is almost impossible to completely avoid odours and smells in indoor air, but a satisfactory result can often be reached by just taking care of the cleanliness and hygiene of the spaces. Therefore, the most important thing is to identify the source of the smell and take action to eliminate it. When thinking about odours and smells, one must also keep in mind that not all individuals find them strenuous and not all smells are by any means negative. On average, the most pleasant smells are felt to be scents that come from nature."
]

function changeQuestionsLang(questions, lang) {

    if(!questions) return;

    if(lang === "en") {

        const quests = questions.map((q, index) => {
            q.title = questionTexts_en[index];
            return q;
        })

        return quests;
    }
    else {
        const quests = questions.map((q, index) => {
            q.title = questionTexts_fi[index];
            return q;
        })

        return quests;     
    }
}

export { 
    emptyQuestions, 
    colors, 
    groups_fi, 
    groups_en, 
    groupIcons, 
    pageTitles_fi, 
    pageTitles_en, 
    initQuestionsValues, 
    info, 
    infoContent_fi, 
    infoContent_en,
    tresh1, 
    tresh2, 
    tresh3,
    changeQuestionsLang
}